import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SortDirective } from './directives/sort.directive';
import { MatAutoCompletePositionDirective } from './directives/mat-autocomplete-position.directive';

@NgModule({
  declarations: [
    SortDirective,
    MatAutoCompletePositionDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SortDirective,
    MatAutoCompletePositionDirective]
})
export class SharedModule { }
